import * as React from 'react';

type CreateEditingStyleModalState = {
    createDialogOpen: boolean;
    openCreateDialog: () => void;
    closeCreateDialog: () => void;
};

export function useCreateEditingStyleModal(): CreateEditingStyleModalState {
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);

    function openCreateDialog() {
        setCreateDialogOpen(true);
    }

    function closeCreateDialog() {
        setCreateDialogOpen(false);
    }

    return { createDialogOpen, openCreateDialog, closeCreateDialog };
}
